import QLITable from "./Table";
import {Nav} from "react-bootstrap";
import {Route, Routes, useLocation} from "react-router-dom";
import AdminHome from "./admin/Home";
import NoAccess from "./admin/NoAccess";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import React from "react";
import packageJson from '../../package.json';


export default function Layout({username, user}) {

  const {pathname} = useLocation();

  return (
    <div className="layout">
      <header className="header">
        <div className="d-flex gap-4 align-items-end">
          <h1 className="header-title">
          <span className="qli-title">
            <Nav.Link as="a" href="/">
              <span className="qli-letter">QLI Artifacts</span>
            </Nav.Link>
          </span>
          </h1>
        </div>
        <div className="user-info">
          {
            (user?.is_qli_admin || user?.is_app_admin) && (
              pathname === "/admin" ? (
                ""
              ) : (
                <Nav.Link
                  as="a"
                  href="/admin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="admin-link"
                  title="Open Admin Panel in a new window"
                >
                  <AdminPanelSettingsIcon fontSize="small" style={{verticalAlign: "sub", marginRight: 2}}/> Admin
                </Nav.Link>
              )
            )
          }
          <span className="user-avatar">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-label="User Icon"
                 xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="4" fill="#888"/>
              <rect x="4" y="16" width="16" height="6" rx="3" fill="#888"/>
            </svg>
          </span>
          <span className="user-name">{username}</span>
        </div>
      </header>
      {user?.release_notes && (
        <div className="release-notes-banner"
            style={{backgroundColor: "#FFCCCC", color: "#333", padding: "16px", margin: "12px", borderRadius: "6px", border: "2px solid #FFB3B3",
                    borderLeft: "4px solid #FF33B3", textAlign: "center", fontSize: "16px", fontWeight: "600", maxHeight: "6rem", overflowY: "auto", overflowX: "auto"}}
            dangerouslySetInnerHTML={{ __html: user.release_notes }}
        />
      )}
      <main className="main-content">
        <Routes>
          <Route path="/admin"
                 element={(user?.is_qli_admin || user?.is_app_admin) ? <AdminHome user={user}/> : <NoAccess/>}/>
          <Route path="*" element={<div className="content-container"><QLITable/></div>}/>
        </Routes>
      </main>
      <footer className="footer">
        <span>Copyright &copy; 2025 - {(new Date().getFullYear())} Qualcomm Incorporated.
          All rights reserved.</span>
        <span>
          App Version: <strong>{packageJson.version}</strong>
        </span>
      </footer>
    </div>
  );
}
